import React from 'react';
import WishListItem from "./WishListItem";

class WishList extends React.Component {
    render() {
        return (
            <div className="render-wish-list">
                <div className="render-wish-list__header">
                    <div className="image">Картинка</div>
                    <div className="title">Название</div>
                    <div className="price">Цена</div>
                    <div className="action">&nbsp;</div>
                    <div className="remove">&nbsp;</div>
                </div>
                <div className="render-wish-list__body">
                    {
                        this.props.items.map(
                            item => <WishListItem
                                key={item.id}
                                item={item}
                                _onRemoveItem={id => this.props._onRemoveItem(id)}
                                _onMoveToBasket={id => this.props._onMoveToBasket(id)}
                            />
                        )
                    }
                </div>
            </div>
        );
    }
}

export default WishList;